import React from 'react';

//axios
import axios from 'axios';
import axiosUrl from '../../axios/url';


export default function Forward(param) {
    const [projectList , setProjectList] = React.useState([]); // 전체 프로젝트 목록
    const [selectedProjectName, setSelectedProjectName] = React.useState('');
    const [selectedProjectId, setSelectedProjectId] = React.useState(''); // 선택한 프로젝트 아이디
    const [link, setLink] = React.useState(''); // 선택한 프로젝트의 링크정보
    const [newLink, setNewLink] = React.useState(''); // 선택한 프로젝트의 링크정보
    const [isNull, setIsNull] = React.useState(false); // link정보가 빈공백인지 null인지를 화면에서 구분하기 어려워 변수를 둠.

    function onClickProjectName(id, name){ selectProject(id, name); }

    // 프로젝트 목록 조회
    async function getProjectList(){
        var url = axiosUrl.project;
        await axios.get(url,{
            params:{
                page: '-1',
                sort: 'createdAt',
                order:'desc'
            }
        })
        .then( response => {
            if(JSON.stringify(projectList) !== JSON.stringify(response.data)) { 
                setProjectList(response.data);
                
                var arr = response.data;
                var size = arr.length ;
                if(size > 0)  selectProject(arr[0].id, arr[0].name);
            }
        })
        .catch(function (e) {
                console.error('[MEDIEX_CMS_2019_ERROR] Forward.getProjectList - ' + e.response.data.error.message);
        });
    }

    // 링크정보 조회
    async function getLink(projectId){
        var url = axiosUrl.forward  + projectId + '/forward';
        await axios.get(url,{})
        .then( response => {
 
            if(response.data !== null) {
                
                if(JSON.stringify(selectedProjectId) !== JSON.stringify(response.data.project.id)) { 
                    setLink(response.data.url) ;
                    setNewLink(response.data.url);
                    setIsNull(false);
                }
            }else{
                setLink('');
                setNewLink('');
                setIsNull(true);
            }
        })
        .catch(function (e) {
                console.error('[MEDIEX_CMS_2019_ERROR] Forward.getLink - ');
        });
    }

    function selectProject(projectId, projectName){
        setSelectedProjectName(projectName);
        setSelectedProjectId(projectId);

        //if(selectedProjectId !== projectId) setLink('');

        // 링크정보 가져오기
        getLink(projectId);
    }

    function handleLink(e){
        setNewLink(e.target.value);
    }

    // 링크 create
    async function saveLink(){
        //if(!window.confirm('링크 정보를 등록하시겠습니까?')) return;
        var url = axiosUrl.forward + selectedProjectId + '/forward';
        await axios.post(url,{
            url:newLink
        })
        .then(function (response){
            //alert('링크 정보를 추가하였습니다.');
            setIsNull(false);
        })
        .catch(function (e) {
            alert('실패했습니다. 다시 시도하세요.');
                console.error('[MEDIEX_CMS_2019_ERROR] Forward.saveLink - ' + e.response.data.error.message);
        });

    }

    // 링크 update
    async function updateLink(){
        if(!window.confirm('링크 정보를 변경하시겠습니까?')) return;
        var url = axiosUrl.forward + selectedProjectId + '/forward';
        await axios.put(url,{
            url:newLink
        })
        .then(function (response){
            alert('링크 정보를 변경하였습니다.');
            setIsNull(false);
        })
        .catch(function (e) {
            alert('링크 정보 변경에 실패했습니다. 다시 시도하세요.');
            console.error('[MEDIEX_CMS_2019_ERROR] Forward.update - ' + e.response.data.error.message);
        });

        selectProject(selectedProjectId, selectedProjectName);
    }

    React.useEffect(() => {
        getProjectList();
    });


    return(
        <div>
            <div className="content-wrapper">
            <section className="content-header">
            <div className="container-fluid">
                <div className="row mb-2">
                    <div className="col-sm-6">
                        <h1>포워딩</h1>
                    </div>
                </div>
            </div>
            </section>

            <section className="content">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-3">
                                <div className="sticky-top mb-3">
                                    <div className="card">
                                        <div className="card-header  contentColor">
                                            <h4 className="card-title">프로젝트</h4>
                                        </div>
                                        
                                        {/* fixed-panel 이걸 div card-body에 추가하면 높이가 고정 됨 */}
                                        <div className="card-body ">
                                            <div id="external-events" >
                                                <ul className="nav nav-pills flex-column" >
                                                    { 
                                                        projectList.map( (value, i) =>
                                                            <li className="nav-item active cursor-pointer" key={i} onClick={() => onClickProjectName(value.id, value.name)} >
                                                                {value.name}
                                                            </li>
                                                        )
                                                    }
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                        
                                </div>
                            </div>
                           
                            <div className="col-md-9">
                                <div className="card">
                                    <div className="card-header  contentColor">
                                        <h4 className="card-title ">{selectedProjectName}</h4>
                                    </div>
                                    
                                    <div className="card-body">
                                        <div id="external-events">
                                            <div className="card card-primary">
                                                <div className="card-body p-0">
                                                    <div className="list-group">
                                                        <div className="table-responsive mailbox-messages">
                                                            { isNull &&  <input type="text" className="form-control" onChange={handleLink} /> }
                                                            { !isNull &&  <input type="text" className="form-control" onChange={handleLink} value={newLink} /> }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {
                                            isNull &&  
                                            <div className="modal-footer">
                                                <button type="button" className="btn btn-primary" onClick={saveLink} >등록</button>
                                            </div>
                                        }
                                        
                                        {
                                            !isNull &&  
                                            <div className="modal-footer">
                                                <button type="button" className="btn btn-primary" onClick={updateLink} >변경</button>
                                            </div>
                                        }
                                    </div>
                                </div>

                            </div>      
                        </div>
                    </div>
                </section>

        </div>
        </div>
        


    );
}